import { TButtonType } from '@hg/stylizator/dist/esm/components/atoms/Button/models'
import { themeColors } from '@hg/stylizator/utils'

interface IThemeData {
  leftButtonStyle: TButtonType
  rightButtonStyle: TButtonType
  specialTheme: boolean
  isHeroCampaignCTAVisible: boolean
  backgroundColor: string
  headingTextColor: string
  headingSmallTextColor: string
  footerTextColor: string
  backgroundBlobColor: string
}

export interface IThemeTypeData {
  default: IThemeData
  mintgreen: IThemeData
  christmas: IThemeData
  special: IThemeData
}

export const ThemeTypeData: IThemeTypeData = {
  default: {
    leftButtonStyle: 'primary',
    rightButtonStyle: 'secondary',
    specialTheme: false,
    isHeroCampaignCTAVisible: true,
    backgroundColor: themeColors.blue[5],
    headingTextColor: themeColors.gray[90],
    headingSmallTextColor: themeColors.gray[90],
    footerTextColor: themeColors.gray[90],
    backgroundBlobColor: themeColors.blue[10],
  },
  mintgreen: {
    leftButtonStyle: 'primary',
    rightButtonStyle: 'secondary',
    specialTheme: false,
    isHeroCampaignCTAVisible: true,
    backgroundColor: '#C3E7D1',
    headingTextColor: themeColors.gray[90],
    headingSmallTextColor: themeColors.gray[90],
    footerTextColor: themeColors.gray[90],
    backgroundBlobColor: '#C3E7D1',
  },
  christmas: {
    leftButtonStyle: 'accent',
    rightButtonStyle: 'accent',
    specialTheme: true,
    isHeroCampaignCTAVisible: false,
    backgroundColor: themeColors.blue[60],
    headingTextColor: themeColors.gray[5],
    headingSmallTextColor: themeColors.gray[20],
    footerTextColor: themeColors.gray[5],
    backgroundBlobColor: themeColors.blue[10],
  },
  special: {
    leftButtonStyle: 'accent',
    rightButtonStyle: 'primary',
    specialTheme: true,
    isHeroCampaignCTAVisible: false,
    backgroundColor: themeColors.gray[100],
    headingTextColor: themeColors.gray[5],
    headingSmallTextColor: themeColors.gray[20],
    footerTextColor: themeColors.gray[5],
    backgroundBlobColor: themeColors.gray[5],
  },
}
